module.exports = __webpack_public_path__ + "static/media/sushi.9964405e.svg";